import {Component, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ObjectPageComponent} from 'features/core/shared/object/mvs-object-page-component/object-page.component';
import {MvsCoreService} from 'features/core/shared/service/mvs-core.service';
import {PageHeaderConfig} from 'features/core/shared/service/page/page-header-config.interface';

/**
* Object-Page for cn.CommissionStatement.
*
* Routed shell at cn/commission-statement/:id. Extends ObjectPageComponent, which reads the :id route
* param, builds the ObjectIdentifier for cn.CommissionStatement and dynamically hosts the registered
* object component (CnCommissionStatementObjectComponent, wired in CN_ENTITY_PROVIDER via objectComponent[])
* through the ObjectInplaceDirective.
*
* Header runs in Template-Mode; getPageHeaderConfig() returns null until objectIdentifier?.objectId is
* set (null-guard) so the header only renders once the statement is resolved.
*/
@Component({
    selector: 'mvs-cn-commission-statement-object-page',
    templateUrl: './cn-commission-statement-object.page.html',
    styleUrls: ['./cn-commission-statement-object.page.scss'],
    standalone: false
})
export class CnCommissionStatementObjectPage
    extends ObjectPageComponent
    implements OnInit, OnDestroy, OnChanges {

    defaultLabel: string = 'Kontoauszug';

    constructor(
        protected override route: ActivatedRoute,
        protected override coreService: MvsCoreService
    ) {
        super(route, coreService);
    }

    override ngOnInit(): void {
        this.defaultLabel = 'Kontoauszug';
        super.ngOnInit();
    }

    protected override getObjectType(): string {
        return 'cn.CommissionStatement';
    }

    // headerTemplate is inherited from PageComponent — do NOT redeclare.

    getPageHeaderConfig(): PageHeaderConfig {
        // Null-guard: render the header only once the statement is resolved.
        if (!this.objectIdentifier?.objectId) {
            return null;
        }
        return {
            templateRef: this.headerTemplate,
            sticky: true
        };
    }
}
